<template>

  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
            <div align="left" @click="goBack"> <b-link>Atras</b-link></div>

            <h1>Inspecciones {{typeNameTypeInspection}} Evaluacion {{index}} Lote {{NumLot}} </h1>
           
            <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable" style="text-align: center">
              <div slot="beforeLimit">
                <download-excel
                  class  = "btn"
                 :fetch  = "fetchData"
               
                 :before-generate = "startDownload"
                 :before-finish = "finishDownload">
                  <b-link>Descargar</b-link>
                </download-excel>
              </div>

              <template slot="afterFilter">
            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
            </tr>
          </template>


              <template slot="resultado" slot-scope="props">
                  <b-badge href="" :style="'color:white;background-color:'+props.row.color" >{{props.row.clasification}}</b-badge>
              </template>


               <template slot="fecha" slot-scope="props">
               {{formatDate(props.row.created_at)}} 
              </template>

              

            <div class="text-right" slot="actions" slot-scope="props">
                 <div style="text-align: center">
            <a target="_blank" href="#" @click.prevent="showQualityReportModal(props.row)" class="fa fa-lg fa fa-search text-black-50" title="Ver"></a>&nbsp;
            <a target="_blank" href="#" @click.prevent="showFormMailModal(props.row)" class="fa fa-lg fa fa-send text-black-50" title="Enviar por correo"></a>&nbsp;
                </div>
          </div>

           </v-server-table>


           <b-modal
         
          v-model="modalShown"
          centered size="lg"
          :title=titleModal
          hide-footer
        >

          <component :is="componenteActual" :objReportQc="objReportQc"  :ref="report">
          </component>

  
        </b-modal>



            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'

import ReportQC from './ReportQC.vue'
import FormEmailQC from './FormMail.vue'

import JsonExcel from 'vue-json-excel'
import moment from 'moment';
import numeral from 'numeral';
import locales from 'numeral/locales'

window.axios = require('axios');

Vue.component('downloadExcel', JsonExcel);

Vue.use(ServerTable);

export default {
  name: 'ListInspecciones',
  components: {
    ServerTable,
  },
  mounted() {
      Event.$on('vue-tables.loading', ()=>{
          this.loading = true;
      });
      Event.$on('vue-tables.loaded',()=>{
          this.loading = false;
      });
     },
  props: ['LotID','typeInspectionID','NumLot','typeNameTypeInspection','inspection_data_id','index'],
  data () {
    return {
      loading: false,
       modalShown:false,
       componenteActual: '',
       report:'',
       titleModal:'',
       objReportQc:{},
      json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        columns: [
          // 'id',
         
          'lot.waybill',
          'lot.origin',
          'lot.product_name',
          'lot.variety',
         
        
          'resultado',
          'result',
          'inspector',
          'fecha',
          'actions',
        ],

   
        data: [],
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        options: {
           responseAdapter: function(resp) {
                  const results = resp.data.results;
                  const items = [];
                  for(let key in results){
                    const item = results[key];
                 
              
                    items.push(item)
                  }

                   return {
                        data: items,
                        count: resp.data.count
                   };
                },
          texts: {
                filter: "Filtrar:",
                filterBy: 'Filtrar por {column}',
                count:' ',
                filterPlaceholder:"Buscar...",
                columns:'Columnas',
                limit:"Registros:",
            },
          perPage: 10,
          perPageValues: [10,25,50,100],
          debounce: 700,
          // columnsDropdown: true,
          filterByColumn: false,
          headings: {
          
            'lot.waybill': 'Guia',
            'lot.origin': 'Productor',
            'lot.product_name': 'Producto',
            'lot.variety': 'Variedad',
            
            'result': 'Porcentaje',
            'actions':'Acciones'
          },

    
          sortable: [],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            dropdown: false,
            chunk: 10
          }
        },
     
    }
  },
  computed:{
      url(){
        return '/api/qc/lotqc/detail_qc_lot_inspection/?' +
          'LotID=' + this.LotID +
          '&typeInspectionID=' +this.typeInspectionID+
          '&inspection_data_id=' +this.inspection_data_id;
      },
    },
  methods: {
    async fetchData(){
        
        const response = await this.$axios.get('/api/qc/lotqc/detail_qc_lot_inspection/?' +
          'LotID=' + this.LotID +
          '&typeInspectionID=' +this.typeInspectionID+
          '&inspection_data_id=' +this.inspection_data_id);

        return response.data.results;
      },
      startDownload(){
          this.loading=true
      },
      finishDownload(){
          this.loading=false
      },
    forceFileDownload(response, a){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Packing List - Embarque #'+a+'.xlsx') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
     showQualityReportModal(a)
      {    

          this.titleModal="Informe de calidad";
  
          this.modalShown=true;
          this.objReportQc=a;
  
          this.componenteActual=ReportQC;
          
          this.report = 'report';
          this.$nextTick(function () {
             this.$refs.report.loadDataInspection();
            })

      },
       showFormMailModal(a)
      {

          this.titleModal="Enviar informe de calidad";

          this.modalShown=true;
          this.objReportQc=a;
  
          this.componenteActual=FormEmailQC;
          
          this.report = 'report';
          this.$nextTick(function () {
       
            })

      },
        formatDate: function (date) {
          return moment(date).format('DD-MM-YYYY h:mm');
        },

    onComplete(){
     
    },
     goBack(){

    this.$router.go(-1)

   
    },
  },
  beforeMount(){

  },

}
</script>


<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .table td {
      padding: 0.30em;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.12rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }
    .VueTables__date-filter {
      border: 1px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }
    .VueTables__number-field {
      border: 4px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }
    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>



